import { useFormContext } from 'react-hook-form';

import { Title } from 'src/components/pages/Portfolio/styles';

const PortfolioTitle = ({
  registerName,
  placeholder
}: {
  registerName: string;
  placeholder: string;
}) => {
  const methods = useFormContext();

  return (
    <Title placeholder={placeholder} {...methods.register(registerName)} />
  );
};

export default PortfolioTitle;
